import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import Select from "react-select";

import { close } from "react-icons-kit/fa/close";

import moment from "moment";
import get from "lodash/get";
import CartTitle from "../../components/CartTitle";
import { Icon } from "react-icons-kit";
import { calendar } from "react-icons-kit/fa/calendar";
import { ic_file_upload } from "react-icons-kit/md/ic_file_upload";

import Loader from "../Loader";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MultiSelect from "../MultiSelect";

import "../../assets/scss/components/MeterialTable/index.scss";
import ReactDatePicker from "react-datepicker";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { validation } from "../../helpers/validation";
import PartnerPreviewPage from "../PartnerPreviewPage";
const _ = { get };

export default class PartnerPersonalForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      primaryCallingCode: "+91",
      primaryNumber: "",
      secondaryCallingCode: "+91",
      secondaryNumber: "",
      bio: "",
      website: "",
      instagram: "",
      thumbnailImage: "",
      country: "",
      countryCode: "",
      region: [],
      servicesOfferCounties: [],
      establishYear: "",
      motorcycleModels: [],
      offerMotorcycle: false,
      guidedTours: false,
      selfRental: false,
      regionRating: "",
      countryRating: "",
      images: [],
      video: "",
      countryList: [],
      partnerId: "",
      startPoint: "",
      startPointSourceLatitude: "",
      startPointSourceLongitude: "",
      errors: {},
      imagePlaceHolder: [],
      thumbnailImagePlaceHolder: "",
      thumbnailListingMobile: "",
      thumbnailListingMobilePlaceHolder: "",
      thumbnailListingDesktop: "",
      thumbnailListingDesktopPlaceHolder: "",
      thumbnailDetailMobile: "",
      thumbnailDetailMobilePlaceHolder: "",
      thumbnailDetailDesktop: "",
      thumbnailDetailDesktopPlaceHolder: "",
      imageUpload: "",
      videoPlaceHolder: "",
      json: [],
      servideCountriesJson: [],
      thumbnailDetailBannerMobile: "",
      thumbnailDetailBannerMobilePlaceHolder: "",
      thumbnailDetailBannerDesktop: "",
      thumbnailDetailBannerDesktopPlaceHolder: "",
      thumbnailVideo: "",
      thumbnailVideoPlaceHolder: "",
      locality: null,
      togglePreviewModal: false,
      files: [],
      errorsImage: [],
      updatedDetails: {},
      isGalleryUpdated: false,
    };
  }

  handleOnChange = (e) => {
    let state = { ...this.state };
    if (
      e.target.name === "offerMotorcycle" ||
      e.target.name === "guidedTours" ||
      e.target.name === "selfRental"
    ) {
      state[e.target.name] = JSON.parse(e.target.value);
    } else {
      state[e.target.name] = e.target.value;
      let errorMessage = validation(
        e.target.name,
        e.target.value,
        this.props.elements
      );
      if (errorMessage) {
        state.errors[e.target.name] = errorMessage;
      } else {
        delete state.errors[e.target.name];
      }
    }
    if (this.props.formType == "update") {
      if (e.target.name === "website") {
        state.updatedDetails = {
          ...state.updatedDetails,
          social: "social",
        };
      } else if (e.target.name === "instagram") {
        state.updatedDetails = {
          ...state.updatedDetails,
          social: "social",
        };
      } else if (
        e.target.name === "primaryNumber" ||
        e.target.name === "primaryCallingCode"
      ) {
        state.updatedDetails = {
          ...state.updatedDetails,
          primaryNumber: "primaryNumber",
        };
      } else if (
        e.target.name === "secondaryNumber" ||
        e.target.name === "secondaryCallingCode"
      ) {
        state.updatedDetails = {
          ...state.updatedDetails,
          secondaryNumber: "secondaryNumber",
        };
      } else if (e.target.name === "regionRating") {
        state.updatedDetails = {
          ...state.updatedDetails,
          rating: {
            country: 0,
            region: JSON.parse(e.target.value),
          },
        };
      } else {
        state.updatedDetails = {
          ...state.updatedDetails,
          [e.target.name]: e.target.value,
        };
      }
    }
    this.setState(state);
  };

  handleYearChange = (e) => {
    let state = { ...this.state };
    state.establishYear = e;
    if (this.props.formType == "update") {
      state.updatedDetails = { ...state.updatedDetails, ["establishYear"]: e };
    }
    this.setState(state);
  };

  handleMotorCycleChange = (e) => {
    let state = { ...this.state };
    state.motorcycleModels = e;
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["motorcycleModels"]: state.motorcycleModels.map((item) => item.value),
      };
    }
    this.setState(state);
  };

  handleCountriesOperation = (e) => {
    let state = { ...this.state };
    state.servicesOfferCounties = e;
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["servicesOfferCounties"]: state.servicesOfferCounties.map(
          (item) => item.value
        ),
      };
    }
    this.setState(state);
  };

  handleChangeStartingLocation = (startPoint) => {
    this.setState({ startPoint });
  };

  handleSelectGeoAddressForStartPoint = (startPoint) => {
    this.setState({ startPoint: startPoint });
    geocodeByAddress(startPoint)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          startPointSourceLatitude: lat,
          startPointSourceLongitude: lng,
        });
        this.setState({
          updatedDetails: {
            ...this.state.updatedDetails,
            location: startPoint,
            geo: {
              type: "Point",
              coordinates: [lng, lat],
            },
          },
        });
      })
      .catch((error) => console.error("Error", error));
  };
  handleCountryChange = (e) => {
    let state = { ...this.state };
    let locality;
    let countryName;
    if (e.target.value !== "") {
      state.country = e.target.value;
      locality = this.props.countryList && this.props.countryList.length > 0 && this.props.countryList.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].locality;
      countryName = this.props.countryList && this.props.countryList.length > 0 && this.props.countryList.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].country;
      state.countryCode = locality.country;
      state.locality = locality;
    } else {
      state.countryCode = "";
      state.country = "";
    }
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["country"]: countryName,
        // ["countryCode"]: locality.country
      };
    }
    this.setState(state);
  };

  handleGoBack = () => {
    this.props.handleToggleModel();
  };

  uploadUrl = (data) => {
    this.props.uploadUrl(data, this.onImageChangeHandler, "partners");
  };

  uploadGallery = (data) => {
    this.props.uploadGalleryUrl(
      data,
      this.onGalleryImageChangeHandler,
      "partner"
    );
  };

  uploadVideo = (data) => {
    this.props.uploadVideoUrl(data, this.onVideoChangeHandler, "partner");
  };

  handleModal = () => {
    let state = { ...this.state };
    state.togglePreviewModal = !state.togglePreviewModal;
    this.setState(state);
  };

  ValidateImg = (file, widths, heights, callBack) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = function() {
      if (img.width === widths && img.height === heights) {
        callBack(file);
      } else {
        callBack(file, widths, heights, "errors");
      }
    };
  };

  callBackOnUpload = (file, width, height, error) => {
    if (!error) {
      let newState = { ...this.state };
      let errorMessage = "";
      errorMessage = validation(
        newState.imageUpload,
        file.size,
        this.props.elements
      );
      if (errorMessage) {
        toast.error(errorMessage);
        newState.errors[newState.imageUpload] = errorMessage;
      } else {
        delete newState.errors[newState.imageUpload];
        errorMessage = "";

        newState[`${newState.imageUpload}PlaceHolder`] = file.name.split(
          " "
        )[0];
        this.uploadUrl(file);
      }
      this.setState(newState);
    }
    if (error) {
      toast.error(
        `${_.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.galleryImageDimensionValidationElement",
          `Image dimensions must be equal to`
        )} ${width} x ${height}`
      );
    }
  };

  validateGalleryImage = (file, fileslength, index) => {
    let img = new Image();
    let newState = { ...this.state };
    img.src = window.URL.createObjectURL(file);
    let length = index + 1;
    let fileSize = file.size;
    if (fileSize <= 1000000) {
      newState.files.push(file);
    } else {
      if (fileslength === 1) {
        toast.error(
          // _.get(
          //   this.props.elements,
          //   "euToursElement.partnerPersonalFormElement.galleryImageSizeValidationElement",
          "The size of the image should be less than 1 mb"
        );
        // );
      } else {
        newState.errorsImage.push(file);
      }
    }
    if (fileslength === length) {
      this.callBackOnGalleryUpload();
    }
    this.setState(newState);
  };

  validateVideo = (file, widths, heights, callBack) => {
    const videoEl = document.createElement("video");
    videoEl.src = window.URL.createObjectURL(file);
    videoEl.onloadedmetadata = (event) => {
      const { name, type } = file;
      const { videoWidth, videoHeight } = videoEl;
      if (videoWidth === widths && videoHeight === heights) {
        if (file.size <= 10000000) {
          callBack(file);
        } else {
          callBack(file, "error1", widths, heights);
        }
      } else {
        if (file.size <= 10000000) {
          callBack(file, "error2", widths, heights);
        } else {
          callBack(file, "error3", widths, heights);
        }
      }
    };
  };

  callBackOnVideoUpload = (file, error, width, height) => {
    if (file && !error) {
      let newState = { ...this.state };
      newState.videoPlaceHolder = file.name.split(" ")[0];
      this.uploadVideo(file);
      this.setState(newState);
    }
    if (error === "error1") {
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.videoSizeValidationElement",
          "The size of the video should be less than 10 mb"
        )
      );
    }
    if (error === "error2") {
      toast.error(
        `${_.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.videoDimensionValidationElement",
          `Video dimensions must be equal to`
        )} ${width} x ${height}`
      );
    }
    if (error === "error3") {
      toast.error(
        `${_.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.videoDimensionAndSizeValidationElement",
          `The size of the video should be less than 10 mb & Video dimensions must be equal to`
        )} ${width} x ${height}`
      );
    }
  };

  callBackOnGalleryUpload = (length, fileLength) => {
    let newState = { ...this.state };
    if (newState.errorsImage.length >= 1) {
      toast.error(
        // _.get(
        //   this.props.elements,
        //   // "euToursElement.partnerPersonalFormElement.galleryImageSizeValidationElementllll",
        //   "Some of the Image size is more than 1 mb which cannot be uploaded"
        // )
        "Some of the Image size is more than 1 mb which cannot be uploaded"
      );
    }
    {
      console.log("Eee", newState.files.length);
    }
    for (
      let i = newState.imagePlaceHolder.length;
      i < newState.files.length;
      i++
    ) {
      this.uploadGallery(newState.files[i]);
    }
  };
  onImageUpload = (e) => {
    if (
      this.state.thumbnailImage !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.thumbnailImageUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      // this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailPageWidthElement",
          160
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailPageHeightElement",
          190
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;

      this.setState(newState);
    }
    e.target.value = "";
  };

  onthumbnailDesktopImageUpload = (e) => {
    if (
      this.state.thumbnailListingDesktop !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.thumbnailImageUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      // this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailListingPageWidthElement",
          450
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailListingPageHeightElement",
          380
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };
  onthumbnailMobileImageUpload = (e) => {
    if (
      this.state.thumbnailListingMobile !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.thumbnailImageUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );

      this.setState(newState);
    } else {
      // this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailListingPageWidthMobileElement",
          400
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailListingPageHeightMobileElement",
          200
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onthumbnailMobileDetailImageUpload = (e) => {
    if (
      this.state.thumbnailDetailMobile !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.thumbnailImageUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageWidthMobileElement",
          450
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageHeightMobileElement",
          800
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onthumbnailDesktopDetailImageUpload = (e) => {
    if (
      this.state.thumbnailDetailDesktop !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.thumbnailImageUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );

      this.setState(newState);
    } else {
      this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageWidthElement",
          1920
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageHeightElement",
          620
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onVideothumbnailUpload = (e) => {
    if (
      this.state.thumbnailVideo !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.imagesLengthElement",
          "Only 1 image is allowed to upload"
        )
      );

      this.setState(newState);
    } else {
      this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.partnerDetailPageVideoWidthElement",
          1920
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.partnerDetailPageVideoHeightElement",
          600
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onthumbnailDetailBannerDesktop = (e) => {
    if (
      this.state.thumbnailDetailBannerDesktop !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.imagesLengthElement",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageBottomWidthElement",
          1920
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageBottomHeightElement",
          600
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };
  onthumbnailDetailBannerMobile = (e) => {
    if (
      this.state.thumbnailDetailBannerMobile !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.imagesLengthElement",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      this.props.clearingPreviousReducer();
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageBottomWidthMobileElement",
          450
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.thumbnailDetailPageBottomHeightMobileElement",
          480
        ),
        this.callBackOnUpload
      );
      newState.imageUpload = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onImageChangeHandler = (data) => {
    let state = { ...this.state };
    state[state.imageUpload] = data;
    toast.error("Images Uploaded Successfully");
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["thumbnailListingMobile"]: state.thumbnailListingMobile,
        ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
        ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
        ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
        ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
        ["thumbnailImage"]: state.thumbnailImage,
        ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
        ["thumbnailVideo"]: state.thumbnailVideo,
        ["images"]: state.images,
        ["video"]: state.video,
        isGalleryUpdated: true,
        partnerId: this.props.partnerDetailsData._id,
      };
      state.updatedDetails = Object.fromEntries(
        Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
      );
    }
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  onGalleryUpload = (e) => {
    let newState = { ...this.state };
    newState.errorsImage = [];
    if (
      Array.from(e.target.files).length + newState.images.length > 20 ||
      Array.from(e.target.files).length > 20
    ) {
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.imageUploadValidation",
          "Max 20 images are allowed to be upload"
        )
      );
    } else {
      for (let i = 0; i < e.target.files.length; i++) {
        this.validateGalleryImage(e.target.files[i], e.target.files.length, i);
      }
      // let errorMessage = "";
      // for (let i = 0; i < e.target.files.length; i++) {
      //   errorMessage = validation(e.target.name, e.target.files[i].size);
      //   if (errorMessage) {
      //     toast.error(errorMessage);
      //     newState.errors[e.target.name] = errorMessage;
      //   } else {
      //     delete newState.errors[e.target.name];
      //     errorMessage = "";
      //     newState.imagePlaceHolder.push(e.target.files[i].name.split(" ")[0]);
      //     this.uploadGallery(e.target.files[i]);
      //   }
      // }
    }
    e.target.value = "";
    this.setState(newState);
  };

  onGalleryImageChangeHandler = (data) => {
    let state = { ...this.state };
    state.images.push(data);
    state.imagePlaceHolder.push(data);
    state.updatedDetails = {
      ...state.updatedDetails,
      ["images"]: state.images,
      ["thumbnailListingMobile"]: state.thumbnailListingMobile,
      ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
      ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
      ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
      ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
      ["thumbnailImage"]: state.thumbnailImage,
      ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
      ["thumbnailVideo"]: state.thumbnailVideo,
      ["video"]: state.video,
      isGalleryUpdated: true,
    };
    state.updatedDetails = Object.fromEntries(
      Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
    );
    state.isGalleryUpdated = true;
    this.setState(state);
    if (state.files.length === state.images.length) {
      toast.error(
        // _.get(
        //   elements,
        //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
        //   "Please select Partner Rating"
        "Images Uploaded Successfully"
      );
    }
  };

  onVideoUpload = (e) => {
    if (this.state.video !== "" || Array.from(e.target.files).length > 1) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.videoUploadValidation",
          "Only 1 video is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      this.validateVideo(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.videoWidthElement",
          1920
        ),
        _.get(
          this.props.elements,
          "euToursElement.partnerDimensionalElement.videoHeightElement",
          600
        ),
        this.callBackOnVideoUpload
      );
    }
    e.target.value = "";
  };

  onVideoChangeHandler = (data) => {
    let state = { ...this.state };
    state.video = data;
    toast.error(
      // _.get(
      //   elements,
      //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
      //   "Please select Partner Rating"
      "Video Uploaded Successfully"
    );
    state.updatedDetails = {
      ...state.updatedDetails,
      ["video"]: data,
      ["images"]: state.images,
      ["thumbnailListingMobile"]: state.thumbnailListingMobile,
      ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
      ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
      ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
      ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
      ["thumbnailImage"]: state.thumbnailImage,
      ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
      ["thumbnailVideo"]: state.thumbnailVideo,
      isGalleryUpdated: true,
    };
    state.isGalleryUpdated = true;
    state.updatedDetails = Object.fromEntries(
      Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
    );
    this.setState(state);
  };

  // handleCountryChangeMobileCode = (e) => {
  handleFormSubmit = () => {
    if (this.props.formType === "create") {
      let state = { ...this.state };
      let { elements } = this.props;
      let data = {
        name: state.name,
        email: state.email,
        primaryCallingCode: state.primaryCallingCode,
        primaryNumber: state.primaryNumber,
        secondaryCallingCode: state.secondaryCallingCode,
        secondaryNumber: state.secondaryNumber,
        bio: state.bio,
        website: state.website,
        instagram: state.instagram,
        thumbnailImage: state.thumbnailImage,
        country: state.country,
        countryCode: state.countryCode,
        region: state.region.map((item) => item.value),
        servicesOfferCounties: state.servicesOfferCounties.map(
          (item) => item.value
        ),
        establishYear: state.establishYear,
        motorcycleModels: state.motorcycleModels.map((item) => item.value),
        offerMotorcycle: state.offerMotorcycle,
        guidedTours: state.guidedTours,
        selfRental: state.selfRental,
        regionRating: state.regionRating,
        countryRating: state.countryRating,
        images: state.images,
        video: state.video,
        locality: state.locality,
        location: state.startPoint,
        thumbnailListingMobile: state.thumbnailListingMobile,
        thumbnailListingDesktop: state.thumbnailListingDesktop,
        thumbnailDetailMobile: state.thumbnailDetailMobile,
        thumbnailDetailDesktop: state.thumbnailDetailDesktop,
        latitude: state.startPointSourceLatitude,
        thumbnailDetailBannerMobile: state.thumbnailDetailBannerMobile,
        thumbnailDetailBannerDesktop: state.thumbnailDetailBannerDesktop,
        thumbnailVideo: state.thumbnailVideo,
        longitude: state.startPointSourceLongitude,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.businessNameValidationElement",
            "Please enter business name"
          )
        );
      if (state.email === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.emailValidationElement",
            "Please enter email address"
          )
        );

      if (state.primaryNumber === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.contactNumberValidationElement",
            "Please enter contact number"
          )
        );
      // if (state.secondaryNumber === "")
      //   return toast.error(
      //     _.get(
      //       elements,
      //       "eventCreateElement.eventNameValidationElementlll",
      //       "Please enter alternate contact number"
      //     )
      //   );
      if (state.startPoint === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.currentLocationValidationElement",
            "Please enter current location"
          )
        );
      if (state.website === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.webisteValidationElement",
            "Please enter website address"
          )
        );

      if (state.instagram === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.instaValidationElement",
            "Please enter instagram account details"
          )
        );
      if (state.regionRating === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
            "Please select Partner Rating"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOperatesValidationElement",
            "Please select country where business operates"
          )
        );
      if (state.region.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionValidationElement",
            "Please select region"
          )
        );
      if (state.servicesOfferCounties.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOfferesValidationElement",
            "Please select countries where business offer services"
          )
        );

      if (state.establishYear === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.establishedYearValidationElement",
            "Please select established year"
          )
        );

      if (state.motorcycleModels.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.reMotocycleValidationElement",
            "Please select the royal enfield motorcycles you have within your fleet"
          )
        );
      if (state.thumbnailImage === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image for landing page"
          )
        );
      }
      if (state.thumbnailListingDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (desktop) for listing page"
          )
        );
      }
      if (state.thumbnailListingMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (mobile) for listing page"
          )
        );
      }
      if (state.thumbnailDetailDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (desktop) for detail page"
          )
        );
      }
      if (state.thumbnailDetailMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (mobile) for detail page"
          )
        );
      }
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.props.handleCreatePartner(data);
      }
    } else if (
      this.props.usertype === "EU Tours Admin" ||
      this.props.usertype === "Admin"
    ) {
      let state = { ...this.state };
      let { elements } = this.props;
      let data = {
        name: state.name,
        primaryCallingCode: state.primaryCallingCode,
        primaryNumber: state.primaryNumber,
        secondaryCallingCode: state.secondaryCallingCode,
        secondaryNumber: state.secondaryNumber,
        bio: state.bio,
        website: state.website,
        instagram: state.instagram,
        thumbnailImage: state.thumbnailImage,
        country: state.country,
        countryCode: state.countryCode,
        region: state.region.map((item) => item.value),
        servicesOfferCounties: state.servicesOfferCounties.map(
          (item) => item.value
        ),
        establishYear: state.establishYear,
        motorcycleModels: state.motorcycleModels.map((item) => item.value),
        offerMotorcycle: state.offerMotorcycle,
        guidedTours: state.guidedTours,
        selfRental: state.selfRental,
        regionRating: state.regionRating,
        countryRating: state.countryRating,
        images: state.images,
        video: state.video,
        locality: state.locality,
        location: state.startPoint,
        latitude: state.startPointSourceLatitude,
        thumbnailListingMobile: state.thumbnailListingMobile,
        thumbnailListingDesktop: state.thumbnailListingDesktop,
        thumbnailDetailMobile: state.thumbnailDetailMobile,
        thumbnailDetailDesktop: state.thumbnailDetailDesktop,
        longitude: state.startPointSourceLongitude,
        thumbnailDetailBannerMobile: state.thumbnailDetailBannerMobile,
        thumbnailDetailBannerDesktop: state.thumbnailDetailBannerDesktop,
        thumbnailVideo: state.thumbnailVideo,
        partnerId: this.props.partnerDetailsData._id,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.businessNameValidationElement",
            "Please enter business name"
          )
        );
      if (state.email === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.emailValidationElement",
            "Please enter email address"
          )
        );

      if (state.primaryNumber === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.contactNumberValidationElement",
            "Please enter contact number"
          )
        );
      if (state.startPoint === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.currentLocationValidationElement",
            "Please enter current location"
          )
        );
      if (state.website === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.webisteValidationElement",
            "Please enter website address"
          )
        );

      if (state.instagram === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.instaValidationElement",
            "Please enter instagram account details"
          )
        );
      if (state.regionRating === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
            "Please select Partner Rating"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOperatesValidationElement",
            "Please select country where business operates"
          )
        );
      if (state.region.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionValidationElement",
            "Please select region"
          )
        );
      if (state.servicesOfferCounties.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOfferesValidationElement",
            "Please select countries where business offer services"
          )
        );

      if (state.establishYear === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.establishedYearValidationElement",
            "Please select established year"
          )
        );

      if (state.motorcycleModels.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.reMotocycleValidationElement",
            "Please select the royal enfield motorcycles you have within your fleet"
          )
        );
      if (state.thumbnailImage === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image for landing page"
          )
        );
      }
      if (state.thumbnailListingDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (desktop) for listing page"
          )
        );
      }
      if (state.thumbnailListingMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (mobile) for listing page"
          )
        );
      }
      if (state.thumbnailDetailDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (desktop) for detail page"
          )
        );
      }
      if (state.thumbnailDetailMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (mobile) for detail page"
          )
        );
      }
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.props.handlePutPartner(data);
      }
    } else {
      let state = { ...this.state };

      let reqObj;
      let { elements } = this.props;
      if (
        state.updatedDetails.hasOwnProperty("social") &&
        !state.updatedDetails.hasOwnProperty("primaryNumber") &&
        !state.updatedDetails.hasOwnProperty("secondaryNumber")
      ) {
        delete state.updatedDetails.social;
        reqObj = {
          ...state.updatedDetails,
          social: {
            website: state.website,
            instagram: state.instagram,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        !state.updatedDetails.hasOwnProperty("social") &&
        state.updatedDetails.hasOwnProperty("primaryNumber") &&
        !state.updatedDetails.hasOwnProperty("secondaryNumber")
      ) {
        delete state.updatedDetails.primaryNumber;
        reqObj = {
          ...state.updatedDetails,
          mobile: {
            callingCode: state.primaryCallingCode,
            number: state.primaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        !state.updatedDetails.hasOwnProperty("social") &&
        !state.updatedDetails.hasOwnProperty("primaryNumber") &&
        state.updatedDetails.hasOwnProperty("secondaryNumber")
      ) {
        delete state.updatedDetails.secondaryNumber;
        reqObj = {
          ...state.updatedDetails,
          secondaryNumber: {
            callingCode: state.secondaryCallingCode,
            number: state.secondaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        state.updatedDetails.hasOwnProperty("social") &&
        state.updatedDetails.hasOwnProperty("primaryNumber") &&
        !state.updatedDetails.hasOwnProperty("secondaryNumber")
      ) {
        delete state.updatedDetails.social;
        delete state.updatedDetails.primaryNumber;
        reqObj = {
          ...state.updatedDetails,
          social: {
            website: state.website,
            instagram: state.instagram,
          },
          mobile: {
            callingCode: state.primaryCallingCode,
            number: state.primaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        !state.updatedDetails.hasOwnProperty("social") &&
        state.updatedDetails.hasOwnProperty("secondaryNumber") &&
        state.updatedDetails.hasOwnProperty("primaryNumber")
      ) {
        delete state.updatedDetails.primaryNumber;
        delete state.updatedDetails.secondaryNumber;
        reqObj = {
          ...state.updatedDetails,
          secondaryNumber: {
            callingCode: state.secondaryCallingCode,
            number: state.secondaryNumber,
          },
          mobile: {
            callingCode: state.primaryCallingCode,
            number: state.primaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        state.updatedDetails.hasOwnProperty("social") &&
        state.updatedDetails.hasOwnProperty("secondaryNumber") &&
        !state.updatedDetails.hasOwnProperty("primaryNumber")
      ) {
        delete state.updatedDetails.social;
        delete state.updatedDetails.secondaryNumber;
        reqObj = {
          ...state.updatedDetails,
          social: {
            website: state.website,
            instagram: state.instagram,
          },
          secondaryNumber: {
            callingCode: state.secondaryCallingCode,
            number: state.secondaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else if (
        state.updatedDetails.hasOwnProperty("social") &&
        state.updatedDetails.hasOwnProperty("secondaryNumber") &&
        state.updatedDetails.hasOwnProperty("primaryNumber")
      ) {
        delete state.updatedDetails.social;
        delete state.updatedDetails.primaryNumber;
        delete state.updatedDetails.secondaryNumber;
        reqObj = {
          ...state.updatedDetails,
          social: {
            website: state.website,
            instagram: state.instagram,
          },
          mobile: {
            callingCode: state.primaryCallingCode,
            number: state.primaryNumber,
          },
          secondaryNumber: {
            callingCode: state.secondaryCallingCode,
            number: state.secondaryNumber,
          },
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      } else {
        reqObj = {
          ...state.updatedDetails,
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          partnerId: this.props.partnerDetailsData._id,
        };
      }
      if (state.name === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.businessNameValidationElement",
            "Please enter business name"
          )
        );
      if (state.email === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.emailValidationElement",
            "Please enter email address"
          )
        );

      if (state.primaryNumber === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.contactNumberValidationElement",
            "Please enter contact number"
          )
        );
      if (state.startPoint === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.currentLocationValidationElement",
            "Please enter current location"
          )
        );
      if (state.website === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.webisteValidationElement",
            "Please enter website address"
          )
        );

      if (state.instagram === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.instaValidationElement",
            "Please enter instagram account details"
          )
        );
      if (state.regionRating === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
            "Please select Partner Rating"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOperatesValidationElement",
            "Please select country where business operates"
          )
        );
      if (state.region.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.regionValidationElement",
            "Please select region"
          )
        );
      if (state.servicesOfferCounties.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.countryBusinessOfferesValidationElement",
            "Please select countries where business offer services"
          )
        );

      if (state.establishYear === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.establishedYearValidationElement",
            "Please select established year"
          )
        );

      if (state.motorcycleModels.length === 0)
        return toast.error(
          _.get(
            elements,
            "euToursElement.partnerPersonalFormElement.reMotocycleValidationElement",
            "Please select the royal enfield motorcycles you have within your fleet"
          )
        );
      if (state.thumbnailImage === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image for landing page"
          )
        );
      }
      if (state.thumbnailListingDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (desktop) for listing page"
          )
        );
      }
      if (state.thumbnailListingMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload thumbnail image (mobile) for listing page"
          )
        );
      }
      if (state.thumbnailDetailDesktop === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (desktop) for detail page"
          )
        );
      }
      if (state.thumbnailDetailMobile === "") {
        return toast.error(
          _.get(
            elements,
            "eventCreateElement.countryValidationElementll",
            "Please upload top banner image (mobile) for detail page"
          )
        );
      }
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        this.props.handleUpdatePartner(reqObj);
      }
    }
  };

  handleDeleteImage = (index) => {
    let state = { ...this.state };
    state.imagePlaceHolder.splice(index, 1);
    state.images.splice(index, 1);
    state.files.splice(index, 1);
    state.updatedDetails = {
      ...state.updatedDetails,
      ["images"]: state.images,
      ["thumbnailListingMobile"]: state.thumbnailListingMobile,
      ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
      ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
      ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
      ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
      ["thumbnailImage"]: state.thumbnailImage,
      ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
      ["thumbnailVideo"]: state.thumbnailVideo,
      ["video"]: state.video,
      isGalleryUpdated: true,
    };
    state.updatedDetails = Object.fromEntries(
      Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
    );
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  handleDeleteThumbnailImage = (name, placeholder) => {
    let state = { ...this.state };
    state[placeholder] = "";
    state[name] = "";
    state.updatedDetails = {
      ...state.updatedDetails,
      ["images"]: state.images,
      ["thumbnailListingMobile"]: state.thumbnailListingMobile,
      ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
      ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
      ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
      ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
      ["thumbnailImage"]: state.thumbnailImage,
      ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
      ["thumbnailVideo"]: state.thumbnailVideo,
      ["video"]: state.video,
      isGalleryUpdated: true,
    };
    state.updatedDetails = Object.fromEntries(
      Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
    );
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  handleDeleteVideo = () => {
    let state = { ...this.state };
    state.videoPlaceHolder = "";
    state.video = "";
    state.updatedDetails = {
      ...state.updatedDetails,
      ["images"]: state.images,
      ["thumbnailListingMobile"]: state.thumbnailListingMobile,
      ["thumbnailDetailBannerDesktop"]: state.thumbnailDetailBannerDesktop,
      ["thumbnailDetailBannerMobile"]: state.thumbnailDetailBannerMobile,
      ["thumbnailDetailDesktop"]: state.thumbnailDetailDesktop,
      ["thumbnailDetailMobile"]: state.thumbnailDetailMobile,
      ["thumbnailImage"]: state.thumbnailImage,
      ["thumbnailListingDesktop"]: state.thumbnailListingDesktop,
      ["thumbnailVideo"]: state.thumbnailVideo,
      ["video"]: state.video,
      isGalleryUpdated: true,
    };
    state.updatedDetails = Object.fromEntries(
      Object.entries(state.updatedDetails).filter(([_, v]) => v != "")
    );
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  handleRegionChanges = (e) => {
    let state = { ...this.state };
    state.region = e;
    state.servicesOfferCounties = [];
    let data2 = [];
    for (var i = 0; i < state.region.length; i++) {
      data2 = [].concat(data2, this.props.regionJson[state.region[i].value]);
    }
    let data3 = [];
    data2.map((o) => data3.push({ value: o, label: o }));
    state.servideCountriesJson = data3;
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["region"]: state.region.map((item) => item.value),
      };
    }
    this.setState(state);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.images !== this.state.images) {
      let state = { ...this.state };
      // state.files = [];
      // this.setState(state);
    }
  }

  componentDidMount() {
    let data = [];
    if (this.props.countryList && this.props.countryList.length> 0)
      this.props.countryList.map((o) =>
        data.push({ value: o.country, label: o.country })
      );
    let state = { ...this.state };
    state.countryList = data;
    this.setState(state);
    if (this.props.partnerDetailsData) {
      let state = { ...this.state };
      state.name =
        this.props.partnerDetailsData && this.props.partnerDetailsData.name;
      state.email =
        this.props.partnerDetailsData && this.props.partnerDetailsData.email;
      state.primaryCallingCode =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.mobile.callingCode;
      state.primaryNumber =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.mobile.number;
      state.secondaryCallingCode =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.secondaryNumber.callingCode;
      state.startPointSourceLatitude =
        this.props.partnerDetailsData && this.props.partnerDetailsData.latitude;
      state.startPointSourceLongitude =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.longitude;
      state.secondaryNumber =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.secondaryNumber.number;
      state.bio =
        this.props.partnerDetailsData && this.props.partnerDetailsData.bio;
      state.website =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.social.website;
      state.instagram =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.social.instagram;
      state.thumbnailImage =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailImage;
      state.thumbnailImagePlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailImage &&
        this.props.partnerDetailsData.gallery.thumbnailImage.split("/")[4];
      state.thumbnailDetailBannerDesktop =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerDesktop;
      state.thumbnailDetailBannerDesktopPlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerDesktop &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerDesktop.split(
          "/"
        )[4];
      state.thumbnailDetailBannerMobile =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerMobile;
      state.thumbnailDetailBannerMobilePlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerMobile &&
        this.props.partnerDetailsData.gallery.thumbnailDetailBannerMobile.split(
          "/"
        )[4];
      state.thumbnailVideo =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailVideo;
      state.thumbnailVideoPlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailVideo &&
        this.props.partnerDetailsData.gallery.thumbnailVideo.split("/")[4];
      state.country =
        this.props.partnerDetailsData && this.props.partnerDetailsData.country;
      state.countryCode =
        this.props.partnerDetailsData && this.props.partnerDetailsData.country;
      state.locality =
        this.props.partnerDetailsData && this.props.partnerDetailsData.locality;
      state.region =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.region &&
        this.props.partnerDetailsData.region.map((item) => ({
          value: item,
          label: item,
        }));
      if (this.props.regionJson) {
        let data = Object.keys(this.props.regionJson);
        let data2 = [];
        data.map((o) => data2.push({ value: o, label: o }));
        state.json = data2;
      }
      if (
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.region
      ) {
        let data2 = [];
        for (var i = 0; i < this.props.partnerDetailsData.region.length; i++) {
          data2 = [].concat(
            data2,
            this.props.regionJson[
              this.props.partnerDetailsData &&
                this.props.partnerDetailsData.region[i]
            ]
          );
        }
        let data3 = [];
        data2.map((o) => data3.push({ value: o, label: o }));
        state.servideCountriesJson = data3;
      }
      state.servicesOfferCounties =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.servicesOfferCounties &&
        this.props.partnerDetailsData.servicesOfferCounties.map((item) => ({
          value: item,
          label: item,
        }));
      state.establishYear =
        this.props.partnerDetailsData &&
        new Date(this.props.partnerDetailsData.establishYear);
      state.motorcycleModels =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.motorcycleModels &&
        this.props.partnerDetailsData.motorcycleModels.map((item) => ({
          value: item,
          label: item,
        }));
      state.offerMotorcycle =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.offerMotorcycle;
      state.guidedTours =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.guidedTours;
      state.selfRental =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.selfRental;
      state.startPoint =
        this.props.partnerDetailsData && this.props.partnerDetailsData.location;
      state.regionRating =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.rating &&
        this.props.partnerDetailsData.rating.region &&
        this.props.partnerDetailsData.rating.region.toString();
      state.countryRating =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.rating &&
        this.props.partnerDetailsData.rating.country &&
        this.props.partnerDetailsData.rating.country.toString();
      for (
        let i = 0;
        i < this.props.partnerDetailsData.gallery.images.length;
        i++
      ) {
        state.images.push(this.props.partnerDetailsData.gallery.images[i]);
        state.imagePlaceHolder.push(
          this.props.partnerDetailsData.gallery.images[i]
        );
        state.files.push(this.props.partnerDetailsData.gallery.images[i]);
      }
      state.video =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.video;
      state.videoPlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.video &&
        // Object.keys(this.props.partnerDetailsData.gallery.video).length > 0 &&
        this.props.partnerDetailsData.gallery.video.split("/")[4];
      state.thumbnailDetailDesktop =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailDesktop;
      state.thumbnailDetailDesktopPlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailDesktop &&
        this.props.partnerDetailsData.gallery.thumbnailDetailDesktop.split(
          "/"
        )[4];
      state.thumbnailDetailMobile =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailMobile;
      state.thumbnailDetailMobilePlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailDetailMobile &&
        this.props.partnerDetailsData.gallery.thumbnailDetailMobile.split(
          "/"
        )[4];
      state.thumbnailListingDesktop =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailListingDesktop;
      state.thumbnailListingDesktopPlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailListingDesktop &&
        this.props.partnerDetailsData.gallery.thumbnailListingDesktop.split(
          "/"
        )[4];
      state.thumbnailListingMobile =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailListingMobile;
      state.thumbnailListingMobilePlaceHolder =
        this.props.partnerDetailsData &&
        this.props.partnerDetailsData.gallery &&
        this.props.partnerDetailsData.gallery.thumbnailListingMobile &&
        this.props.partnerDetailsData.gallery.thumbnailListingMobile.split(
          "/"
        )[4];
      state.partnerId =
        this.props.partnerDetailsData && this.props.partnerDetailsData._id;
      this.setState(state);
    }
    if (
      (this.props.usertype === "EU Tours Admin" ||
        this.props.usertype === "Admin") &&
      this.props.regionJson &&
      this.props.editInfo !== true
    ) {
      let state = { ...this.state };
      let data = Object.keys(this.props.regionJson);
      let data2 = [];
      data.map((o) => data2.push({ value: o, label: o }));
      state.json = data2;
      this.setState({ ...state });
    }
  }

  render() {
    let { elements } = this.props;
    console.log("Est", this.state);
    console.log("motorCycle", this.props.motorCycle);
    console.log(
      "countryCODE",
      this.props.countryMobileCode.sort(function(a, b) {
        return parseInt(a.callingCode) - parseInt(b.callingCode);
      })
    );
    const renderFunc = ({
      getInputProps,
      suggestions,
      getSuggestionItemProps,
      loading,
    }) => (
      <div>
        <Input
          className="input-text"
          {...getInputProps({
            placeholder: _.get(
              elements,
              "euToursElement.partnerPersonalFormElement.searchPlacesElement",
              "Search Places ..."
            ),
          })}
        />
        <div className="autocomplete-dropdown-container">
          {loading && <div>Loading...</div>}
          {suggestions.map((suggestion) => {
            const className = suggestion.active
              ? "suggestion-item"
              : "suggestion-item";
            const style = suggestion.active
              ? { backgroundColor: "#fafafa", cursor: "pointer" }
              : { backgroundColor: "#ffffff", cursor: "pointer" };
            return (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
    return (
      <div className="hideSearch mt-4">
        {this.state.images &&
          this.state.files &&
          this.state.images.length !== this.state.files.length && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailImage === "" &&
          this.state.thumbnailImagePlaceHolder && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.videoPlaceHolder &&
          this.state.video === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailDetailBannerMobilePlaceHolder &&
          this.state.thumbnailDetailBannerMobile === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailDetailBannerDesktopPlaceHolder &&
          this.state.thumbnailDetailBannerDesktop === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailListingDesktopPlaceHolder &&
          this.state.thumbnailListingDesktop === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailListingMobilePlaceHolder &&
          this.state.thumbnailListingMobile === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailDetailDesktopPlaceHolder &&
          this.state.thumbnailDetailDesktop === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailDetailMobilePlaceHolder &&
          this.state.thumbnailDetailMobile === "" && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailVideoPlaceHolder &&
          this.state.thumbnailVideo === "" && <Loader />}
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "euToursElement.partnerPersonalFormElement.headingElement",
                  "Partner Personal Information"
                )}
                Name={"Filter"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>

            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.subHeadingUserElement",
                            "Personal Details"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col className="each_input mt-2" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.businessNameElement",
                          "Business Name"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"name"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.businessNamePlaceholder",
                          "Business Name"
                        )}
                        customOnChange={this.handleOnChange}
                        customValue={this.state.name}
                      />
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.name && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.name}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input mt-2" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.emailLabel",
                          "Email"
                        )}
                        mandatory
                        inputType={"email"}
                        inputName={"email"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.emailPlaceholder",
                          "Email"
                        )}
                        customOnChange={this.handleOnChange}
                        customValue={this.state.email}
                        disabledType={
                          this.props.formType === "create" ? false : true
                        }
                      />
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.email && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.email}
                          </div>
                        )}
                    </Col>

                    <Col className="each_input mt-2" lg={4}>
                      <Label
                        className="inputLabel label_heading"
                        id="textNumber"
                      >
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.contactNumberElement",
                          "Contact Number"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <div className="phone_card">
                        <FormGroup className="mb-0">
                          <Input
                            type="select"
                            name="primaryCallingCode"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleOnChange}
                            value={this.state.primaryCallingCode}
                          >
                            {this.props.countryMobileCode
                              .sort()
                              .map((item, index) => (
                                <option key={index} value={item.callingCode}>
                                  {`${item.callingCode}`}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>

                        <Input
                          type="number"
                          id="textNumber"
                          name="primaryNumber"
                          className="inputText input_field form-control border-left-0"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.contactNumberElement",
                            "Contact Number"
                          )}
                          maxLength={15}
                          onChange={this.handleOnChange}
                          value={this.state.primaryNumber}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                        />
                      </div>
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.primaryNumber && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.primaryNumber}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label
                        className="inputLabel label_heading"
                        id="textNumber"
                      >
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.altContactNumberElement",
                          "Alternative Contact Number"
                        )}
                      </Label>
                      <div className="phone_card">
                        <FormGroup>
                          <Input
                            type="select"
                            name="secondaryCallingCode"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleOnChange}
                            value={this.state.secondaryCallingCode}
                          >
                            {this.props.countryMobileCode
                              .sort()
                              .map((item, index) => (
                                <option key={index} value={item.callingCode}>
                                  {`${item.callingCode}`}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>

                        <Input
                          type="number"
                          id="textNumber"
                          name="secondaryNumber"
                          maxLength={15}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          className="inputText input_field form-control border-left-0"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.altContactNumberElement",
                            "Alternative Contact Number"
                          )}
                          onChange={this.handleOnChange}
                          value={this.state.secondaryNumber}
                        />
                      </div>
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.secondaryNumber && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.secondaryNumber}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.currentLocationElement",
                          "Current Location"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className="position-relative">
                        <PlacesAutocomplete
                          value={this.state.startPoint}
                          onChange={(startPoint) =>
                            this.handleChangeStartingLocation(startPoint)
                          }
                          onSelect={(startPoint) =>
                            this.handleSelectGeoAddressForStartPoint(startPoint)
                          }
                        >
                          {renderFunc}
                        </PlacesAutocomplete>
                      </FormGroup>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.currentLocationLatitudeElement",
                          "Current Location Latitude"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.startPointSourceLatitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.currentLocationLatitudeElement",
                          "Current Location Latitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.currentLocationLongitudeElement",
                          "Current Location Longitude"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.startPointSourceLongitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.firstNamePlaceholder",
                          "Current Location Longitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.websiteElement",
                          "Website"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"website"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.websitePlaceholder",
                          "https://www.example.com"
                        )}
                        customValue={this.state.website}
                        customOnChange={this.handleOnChange}
                      />
                    </Col>
                    <Col lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.instagramAccountElement",
                          "Instagram Account"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"instagram"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.instagramAccountElement",
                          "Instagram Account"
                        )}
                        customValue={this.state.instagram}
                        customOnChange={this.handleOnChange}
                      />
                    </Col>
                    {this.props && this.props.usertype &&
                      (this.props.usertype === "EU Tours Admin" ||
                      this.props.usertype === "Admin") && (
                        <Col className="each_input" lg={4}>
                          <Label
                            className="inputLabel label_heading"
                            id="textNumber"
                          >
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.partnerRatingElement",
                              "Partner Rating"
                            )}

                            <span className="mandate_mark">*</span>
                          </Label>
                          <select
                            name="regionRating"
                            id="Code"
                            className="w-100 customeSelectBtn form-control"
                            onChange={this.handleOnChange}
                            value={this.state.regionRating}
                          >
                            <option value={""}>Select Rating</option>
                            {this.props.partnerRankingNumber &&
                              this.props.partnerRankingNumber.length > 0 &&
                              this.props.partnerRankingNumber.map((item) => (
                                <option value={item}>{item}</option>
                              ))}
                          </select>
                          {this.state &&
                            this.state.errors &&
                            this.state.errors.regionRating && (
                              <div className="error_msg">
                                {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                                {this.state &&
                                  this.state.errors &&
                                  this.state.errors.regionRating}
                              </div>
                            )}
                        </Col>
                      )}
                    <Col className="each_input mt-2" lg={12}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.shortBioElement",
                          "Short Bio (Profile) Of Your Business"
                        )}
                        inputType={"textarea"}
                        inputName={"bio"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.shortBioPlaceholder",
                          "Short Bio (Profile) Of Your Business"
                        )}
                        customOnChange={this.handleOnChange}
                        customValue={this.state.bio}
                      />
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.bio && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.bio}
                          </div>
                        )}
                    </Col>
                    <Col className="top_line" md="12">
                      <h2 className="title-bar secondary-title font-weight-bold mt-4 my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.subHeadingBusinessElement",
                            "Business Details"
                          )}
                        </span>
                      </h2>
                    </Col>

                    <Col className="each_input mt-2" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.businessOperatesCountries",
                          "Country Where Business Operates"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="country"
                          className="w-100 customeSelectBtn"
                          value={this.state.country}
                          onChange={this.handleCountryChange}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.countryLabel",
                              "All Countries"
                            )}
                          </option>
                          {this.props.countryList &&
                            this.props.countryList.length > 0 &&
                            this.props.countryList
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option key={index} value={item.country}>
                                  {item.country}
                                </option>
                              ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col className="each_input mt-2" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.regionLabel",
                          "Region"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Select
                          // defaultValue={this.state.region}
                          isMulti
                          closeMenuOnSelect={false}
                          isClearable={this.state.isClearable}
                          name="region"
                          options={this.state.json}
                          className="basic-multi-select w-100 customeSelectBtn"
                          classNamePrefix="select"
                          value={this.state.region}
                          onChange={(e) => this.handleRegionChanges(e)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="each_input" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.countryOfferServices",
                          "Countries Where You Offer Your Services"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          isClearable={this.state.isClearable}
                          name="motorcycleModels"
                          options={this.state.servideCountriesJson}
                          className="basic-multi-select w-100 customeSelectBtn"
                          classNamePrefix="select"
                          value={this.state.servicesOfferCounties}
                          onChange={(e) => this.handleCountriesOperation(e)}
                        />
                      </FormGroup>
                    </Col>

                    <Col className="each_input" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.businessEstablishedYear",
                          "Year Your Business Was Established:"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className="confirmRiderSelect select_options personalInfo-datePick">
                        <ReactDatePicker
                          selected={this.state.establishYear}
                          showYearPicker
                          name="establishYear"
                          placeholderText="Established Year"
                          dateFormat="yyyy"
                          onChange={(date) => this.handleYearChange(date)}
                        />
                        <Icon
                          className="text-dark dateIcon"
                          size={18}
                          icon={calendar}
                        />
                      </FormGroup>
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.establishYear && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.establishYear}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.reMotorcycleModel",
                          "Which RE Motorcycles Model Do You Have Within Your Fleet? (Multiple)"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Select
                          // defaultValue={[colourOptions[2], colourOptions[3]]}
                          isMulti
                          closeMenuOnSelect={false}
                          isClearable={this.state.isClearable}
                          name="motorcycleModels"
                          options={this.props.motorCycle.map((item) => ({
                            value: item.motorcycleName,
                            label: item.motorcycleName,
                          }))}
                          className="basic-multi-select w-100 customeSelectBtn"
                          classNamePrefix="select"
                          value={this.state.motorcycleModels}
                          onChange={(e) => this.handleMotorCycleChange(e)}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="each_input" xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.noGuidedToursElement",
                          "Do You Offer Motorcycle Rental For Non-Guided Tours?"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="offerMotorcycle"
                          className="w-100 customeSelectBtn"
                          value={this.state.offerMotorcycle}
                          onChange={this.handleOnChange}
                        >
                          <option value={true}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.yesElement",
                              "Yes"
                            )}
                          </option>
                          <option value={false}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.noElement",
                              "No"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.guidedTourOfferedElement",
                          "Guided Tours Offered"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="guidedTours"
                          className="w-100 customeSelectBtn"
                          value={this.state.guidedTours}
                          onChange={this.handleOnChange}
                        >
                          <option value={true}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.yesElement",
                              "Yes"
                            )}
                          </option>
                          <option value={false}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.noElement",
                              "No"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.selfRentalElement",
                          "Self Rentals Options"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="selfRental"
                          className="w-100 customeSelectBtn"
                          value={this.state.selfRental}
                          onChange={this.handleOnChange}
                        >
                          <option value={true}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.yesElement",
                              "Yes"
                            )}
                          </option>
                          <option value={false}>
                            {_.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.noElement",
                              "No"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col className="top_line" md="12">
                      <h2 className="title-bar secondary-title font-weight-bold mt-4 my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.uploadMediaHeading",
                            "Upload Media"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageLandingPageElement",
                          "Landing Page Filter Thumbnail (160 x 190 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp"
                          name="thumbnailImage"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageLandingPageElement",
                            "Landing Page Filter Thumbnail (160 x 190 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) => this.onImageUpload(e)}
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailImagePlaceHolder !== "" &&
                        this.state.thumbnailImagePlaceHolder !== undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailImagePlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailImage",
                                  "thumbnailImagePlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageLandingPageElement",
                            "Landing Page Filter Thumbnail (160 x 190 px)"
                          )
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageElement",
                          "Partner Listing Page Thumbnail - Desktop (450 x 380 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp"
                          name="thumbnailListingDesktop"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageElement",
                            "Partner Listing Page Thumbnail - Desktop (450 x 380 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) =>
                            this.onthumbnailDesktopImageUpload(e)
                          }
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailListingDesktopPlaceHolder !== "" &&
                        this.state.thumbnailListingDesktopPlaceHolder !==
                          undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailListingDesktopPlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailListingDesktop",
                                  "thumbnailListingDesktopPlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageElement",
                            "Partner Listing Page Thumbnail - Desktop (450 x 380 px)"
                          )
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageMobileElement",
                          "Partner Listing Page Thumbnail - Mobile (400 x 200 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp"
                          name="thumbnailListingMobile"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageMobileElement",
                            "Partner Listing Page Thumbnail - Mobile (400 x 200 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) => this.onthumbnailMobileImageUpload(e)}
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailListingMobilePlaceHolder !== "" &&
                        this.state.thumbnailListingMobilePlaceHolder !==
                          undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailListingMobilePlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailListingMobile",
                                  "thumbnailListingMobilePlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageListingPageMobileElement",
                            "Partner Listing Page Thumbnail - Mobile (400 x 200 px)"
                          )
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageElement",
                          "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp,.tiff"
                          name="thumbnailDetailDesktop"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageElement",
                            "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) =>
                            this.onthumbnailDesktopDetailImageUpload(e)
                          }
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailDetailDesktopPlaceHolder !== "" &&
                        this.state.thumbnailDetailDesktopPlaceHolder !==
                          undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailDetailDesktopPlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailDetailDesktop",
                                  "thumbnailDetailDesktopPlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageElement",
                            "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)"
                          )
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageMobileElement",
                          "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp,.tiff"
                          name="thumbnailDetailMobile"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageMobileElement",
                            "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) =>
                            this.onthumbnailMobileDetailImageUpload(e)
                          }
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailDetailMobilePlaceHolder !== "" &&
                        this.state.thumbnailDetailMobilePlaceHolder !==
                          undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailDetailMobilePlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailDetailMobile",
                                  "thumbnailDetailMobilePlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.thumbnailImageDetailPageMobileElement",
                            "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)"
                          )
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.partnerDetailImageFormatElement",
                          "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)"
                        )}
                      </label>
                      <div className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="thumbnailDetailBannerDesktop"
                          accept=".jpg, .jpeg, .png, .webp"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.partnerDetailImageFormatElement",
                            "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)"
                          )}
                          onChange={(e) =>
                            this.onthumbnailDetailBannerDesktop(e)
                          }
                          className="inputText mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailDetailBannerDesktopPlaceHolder !==
                          "" &&
                        this.state.thumbnailDetailBannerDesktopPlaceHolder !==
                          undefined ? (
                          <div className="file-name my-1 mr-2">
                            <div className="file-large-name">
                              {
                                this.state
                                  .thumbnailDetailBannerDesktopPlaceHolder
                              }
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailDetailBannerDesktop",
                                  "thumbnailDetailBannerDesktopPlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.partnerDetailImageFormatElement",
                            "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)"
                          )
                        )}
                      </div>

                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.partnerDetailMobileImageFormatElement",
                          "Partner Detail Page- Bottom Banner -  Mobile - (450 x 480 px)"
                        )}
                      </label>
                      <div className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="thumbnailDetailBannerMobile"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.partnerDetailMobileImageFormatElement",
                            "Partner Detail Page- Bottom Banner -  Mobile - (450 x 480 px)"
                          )}
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(e) =>
                            this.onthumbnailDetailBannerMobile(e)
                          }
                          className="inputText mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailDetailBannerMobilePlaceHolder !==
                          "" &&
                        this.state.thumbnailDetailBannerMobilePlaceHolder !==
                          undefined ? (
                          <div className="file-name my-1 mr-2">
                            <div className="file-large-name">
                              {
                                this.state
                                  .thumbnailDetailBannerMobilePlaceHolder
                              }
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailDetailBannerMobile",
                                  "thumbnailDetailBannerMobilePlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.partnerDetailMobileImageFormatElement",
                            "Partner Detail Page- Bottom Banner -  Mobile - (450 x 480 px)"
                          )
                        )}
                      </div>

                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.galleryImagesElement",
                          "Gallery Common"
                        )}
                        {/* <span className="mandate_mark">*</span> */}
                      </label>
                      <div className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="images"
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(e) => this.onGalleryUpload(e)}
                          className="inputText mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.imagePlaceHolder &&
                        this.state.imagePlaceHolder.length > 0
                          ? this.state.imagePlaceHolder.map((item, index) => (
                              <div className="file-name my-1 mr-2">
                                <div className="file-large-name">
                                  {item.split("/")[4]}
                                </div>
                                <Icon
                                  className="closeIcon"
                                  size={18}
                                  icon={close}
                                  onClick={() => this.handleDeleteImage(index)}
                                />
                              </div>
                            ))
                          : _.get(
                              elements,
                              "euToursElement.partnerPersonalFormElement.galleryImagesElement",
                              "Gallery Common"
                            )}
                      </div>

                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.galleryImageFormatElement",
                          "Max 20 images allowed. Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.PartnerdetailVideoImagesElement",
                          "Partner Detail Page - Video Poster Image - (1920 x 600 px)"
                        )}
                      </label>
                      <div className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="thumbnailVideo"
                          placeholder={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.PartnerdetailVideoImagesElement",
                            "Partner Detail Page - Video Poster Image - (1920 x 600 px)"
                          )}
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(e) => this.onVideothumbnailUpload(e)}
                          className="inputText mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailVideoPlaceHolder ? (
                          <div className="file-name my-1 mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailVideoPlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailImage(
                                  "thumbnailVideo",
                                  "thumbnailVideoPlaceHolder"
                                )
                              }
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.PartnerdetailVideoImagesElement",
                            "Partner Detail Page - Video Poster Image - (1920 x 600 px)"
                          )
                        )}
                      </div>

                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.thumbnailImageFormatElement",
                          "Format: JPG JPEG PNG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6} className="mb-4">
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.uploadVideosElement",
                          "Upload Videos (1920 x 600 px)"
                        )}
                      </label>
                      <label className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="video"
                          accept=".mp4"
                          onChange={(e) => this.onVideoUpload(e)}
                          className="inputText mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />

                        {this.state.videoPlaceHolder !== "" ? (
                          <div className="file-name my-1 mr-2">
                            <div className="file-large-name">
                              {this.state.videoPlaceHolder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() => this.handleDeleteVideo()}
                            />
                          </div>
                        ) : (
                          _.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.uploadVideosElement",
                            "Upload Videos (1920 x 600 px)"
                          )
                        )}
                      </label>

                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalFormElement.uploadVideosFormatElement",
                          "Only one file allowed. Format: Mp4. Max Size: 10MB."
                        )}
                      </div>
                    </Col>

                    <Col className="top_line" md="12"></Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="d-flex mt-5">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.backButtonElement",
                            "Back"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={this.handleGoBack}
                        />{" "}
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.previewButtonElement",
                            "Preview"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={this.handleModal}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.partnerPersonalFormElement.submitButtonElement",
                            "Submit"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={this.handleFormSubmit}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Modal
          isOpen={this.state.togglePreviewModal}
          toggle={() => this.handleModal()}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <PartnerPreviewPage
              handleToggleModel={() => this.handleModal()}
              partnerDetailsData={this.state}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
